import axios from "axios";
import initializeAxios from "../util/Axios";

class ContentServices {
  constructor() {
    initializeAxios();
  }

  async getImages({ searchTerm, isActive, pageIndex, pageSize }) {
    const response = await axios.get("/api/images", {
      params: {
        searchTerm,
        isActive,
        pageIndex,
        pageSize
      }
    });
    console.log(response.data);
    return response.data;
  }

  async addImage({
    name,
    image,
    isActive
  }) {
    console.log(name,
      image,
      isActive);
    const response = await axios.post("/api/image/add", {
      name,
      image,
      isActive,
    });
    console.log(response);
    return response;
  }

  
  async deleteImage(imageId, isActive) {
    const response = await axios.put("/api/image/delete", {
      imageId,
      isActive
    });

    return response.data;
  }

  async uploadToS3(data) {
    const formData = new FormData();
    for (let key in data) {
      formData.append(key, data[key]);
    }
    const response = await axios.post("/api/util/uploadimage", formData);
    return response.data;
  }

}

export default new ContentServices();
